import React from 'react';
import { Button as AntButton } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { ReorderCard } from '../reorder-card';
import { Tag } from '../tag';
import type { ReorderCardData } from './types';
import style from './style.module.scss';

type ReorderCardItemProps = {
    index: number;
    data: ReorderCardData;
    onEdit: () => void;
};

export function ReorderCardItem({ index, data, onEdit }: ReorderCardItemProps) {
    const imageUrl = data.imageUrl || '';
    const tags =
        data.tags && data.tags.length > 0 ? (
            <div className={style.tags}>
                {data.tags.map((tag) => (
                    <Tag key={tag.label} variant={tag.variant}>
                        {tag.label}
                    </Tag>
                ))}
            </div>
        ) : null;

    return (
        <div className={style.card_item}>
            <ReorderCard
                index={index}
                dragHandle={<span className={style.drag_dots} />}
                status={
                    <Tag variant={data.statusVariant}>{data.statusText}</Tag>
                }
                tags={tags}
                meta={<div className={style.meta}>{data.meta}</div>}
                actions={
                    <div className={style.actions}>
                        <AntButton icon={<EditOutlined />} onClick={onEdit} />
                    </div>
                }
                title={data.title}
                subtitle={data.subtitle || null}
                thumbnail={
                    <div
                        className={style.thumbnail_bg}
                        style={{
                            backgroundImage: imageUrl
                                ? `url(${imageUrl})`
                                : 'none',
                        }}
                    />
                }
            />
        </div>
    );
}
